import { Dialog } from "../../components/dialogs/Dialog";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useLocale } from "../../providers/LocaleProvider";

interface ImportJobConfirmDialogProps {
  open: boolean;
  loading: boolean;
  onConfirm: () => void;
  onClose: () => void;
  theme?: any;
  label?: "Import" | "Import and Edit";
  onImportAndEdit?: () => void;
}

const ImportJobConfirmDialog: React.FC<ImportJobConfirmDialogProps> = ({
  open,
  loading,
  onConfirm,
  onClose,
  theme,
  label = "Import",
  onImportAndEdit
}) => {
  const { translate } = useLocale();
  const isImportAndEdit = label === "Import and Edit";

  return (
    <Dialog
      open={open}
      theme={theme}
      onClose={onClose}
      fullWidth={true}
      maxWidth='sm'
      title={translate("settings.importJob")}
      actions={[
        {
          label: isImportAndEdit ? translate("settings.importAndEdit") : translate("common.import"),
          primary: true,
          variant: "filled",
          disabled: loading,
          onClick: isImportAndEdit ? onImportAndEdit : onConfirm,
          isLoading: loading
        },
        {
          label: translate("common.cancel"),
          onClick: onClose
        }
      ]}
    >
      <Box>
        <Typography>{translate("settings.importJobMessage")}</Typography>
      </Box>
    </Dialog>
  );
};

export default ImportJobConfirmDialog;
